import {
  MERCADOPAGO_ERROR,
  MERCADOPAGO_LOADING,
  MERCADOPAGO_SUCCESS,
  MERCADOPAGO_RESET,
  MERCADOPAGO_REFERENCIA,
  MERCADOPAGO_REFERENCIA_LOADING,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";

export const wsGetMercadoPagoTurnosQr = (idturno, nextStep) => (dispatch) => {
  dispatch({
    type: MERCADOPAGO_LOADING,
  });
  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/turnosQr/qr/${idturno}`)
      .then((res) => {
        if (nextStep) nextStep(true, res.data);

        dispatch({
          type: MERCADOPAGO_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        if (nextStep) nextStep(false, err.response.data);
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "mercadoPagoTurnos",
        };

        dispatch({
          type: MERCADOPAGO_ERROR,
          payload: error,
        });
      });
  });
};

export const wsGetMercadoPagoLaboratorioQr =
  (idprotocolo, funLoading) => (dispatch) => {
    dispatch({
      type: MERCADOPAGO_LOADING,
    });

    axiosInstance().then((respuesta) => {
      respuesta
        .get(`/laboratorioQr/qr/${idprotocolo}`)
        .then((res) => {
          funLoading(true, res.data);
          dispatch({
            type: MERCADOPAGO_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          funLoading(true, err.response.data);
          funLoading(false);
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "mercadoPagoLaboratorio",
          };

          dispatch({
            type: MERCADOPAGO_ERROR,
            payload: error,
          });
        });
    });
  };

export const wsGetMercadoPagoReferencia =
  (referencia, nextStep) => (dispatch) => {
    dispatch({
      type: MERCADOPAGO_REFERENCIA_LOADING,
    });

    axiosInstance().then((respuesta) => {
      respuesta
        .get(`/turnos/qr/referencia/${referencia}`)
        .then((res) => {
          if (nextStep) nextStep(true, res.data);
          dispatch({
            type: MERCADOPAGO_REFERENCIA,
            payload: res.data,
          });
        })
        .catch((err) => {
          if (nextStep) nextStep(false);
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "mercadoPagoLaboratorio",
          };

          dispatch({
            type: MERCADOPAGO_ERROR,
            payload: error,
          });
        });
    });
  };

export const mercadoPagoReset = () => (dispatch) => {
  dispatch({
    type: MERCADOPAGO_RESET,
  });
};
